// extracted by mini-css-extract-plugin
export default {"card":"aIbc1f","external":"bIbc1f","selected":"cIbc1f"};